import { TOKEN_TYPE } from "../TokenType.js";
import Token from "../Token.js";

export default class LeftTupleToken extends Token {
    constructor( value ) {
        super( TOKEN_TYPE.LEFT_TUPLE, value );
    }

    toString() {
        return this.value;
    }
}
